// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';

import { Loader } from '../../../../../../components';
import { getOrder } from './store/selectors';
import * as orderDetailsActions from './store/actions';
import OrderFullDesktop from './components/OrderFullDesktop/OrderFullDesktop';
import OrderFullMobile from './components/OrderFullMobile/OrderFullMobile';
import styles from './styles';

class OrderFull extends Component {
  static propTypes = {
    classes: PropTypes.object,
    match: PropTypes.object,
    requestOrder: PropTypes.func,
    order: PropTypes.any,
    history: PropTypes.any,
    resetOrder: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    match: {},
    requestOrder: () => { },
    resetOrder: () => { },
    order: null,
    history: null,
  };

  componentDidMount() {
    const { history, match } = this.props;
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('loggedID');

    // The :id in the path first, with the router state the Link carries as a
    // fallback. Reading state alone threw "Cannot read properties of undefined
    // (reading 'id')" on a reload or a pasted link, because state only exists
    // when you arrive by clicking.
    const orderId = (match && match.params && match.params.id)
      || ((history.location.state || {}).id);

    this.props.requestOrder({ token, id, orderId });
  }

  componentWillUnmount() {
    this.props.resetOrder();
  }

  render() {
    const { order, classes } = this.props;
    return (
      order ? (
        <MediaQuery minWidth={600}>
          {matches => (matches
            ? <OrderFullDesktop order={order} />
            : <OrderFullMobile order={order} />)}
        </MediaQuery>)
        : <div className={classes.loaderContainer}><Loader /></div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    order: getOrder(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestOrder: data => dispatch(orderDetailsActions.requestOrderDetails(data)),
    resetOrder: () => dispatch(orderDetailsActions.resetOrder()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(OrderFull));
